import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';

import { apiClient } from 'api/apiClient';
import type { IRequestException } from 'api/types/requestException';

interface IDeleteEdmProps {
    id: number;
}

export const deleteEdm = async ({ id }: IDeleteEdmProps): Promise<Response> => {
    const response = await apiClient.delete(`edms/${id}`);
    return response;
};

export const useDeleteEdmMutation = (
    options: UseMutationOptions<Response, IRequestException, IDeleteEdmProps>
) => {
    return useMutation(async (id) => await deleteEdm(id), options);
};
